/**
 * REVIEW COMPANIES REDUX ACTIONS
 *
 * @version 0.1
 */

import { hashHistory } from 'react-router';

import reduxStore from './../../reduxStore';
import xhr from './../../utils/xhr';
import utils from './../../utils/utilities';

import { POPUP_LIFETIME } from './../../constants';
import headerActions from './../../reusable/Header/Header.actions';
import popupActions from './../../reusable/MessagePopup/redux/MessagePopup.actions';
import categoriesApi from './../../api/Categories.api';


// Define action constants
export const RSS_LISTING_INITIAL_PHASE = 'RSS_LISTING_INITIAL_PHASE';
export const RSS_LISTING_COUNT = 'RSS_LISTING_COUNT';
export const RSS_LISTING_WARNING_HIDDEN = 'RSS_LISTING_WARNING_HIDDEN';
export const RSS_LISTING_LOAD_CATEGORIES = 'RSS_LISTING_LOAD_CATEGORIES';
export const RSS_LISTING_WARNING_SHOWN = 'RSS_LISTING_WARNING_SHOWN';
export const RSS_LISTING_SELECT_ITEM = 'RSS_LISTING_SELECT_ITEM';
export const RSS_LISTING_DESELECT_ITEM = 'RSS_LISTING_DESELECT_ITEM';
export const RSS_LISTING_REFRESH_FEEDS = 'RSS_LISTING_REFRESH_FEEDS';
export const RSS_LISTING_RESET_SELECTED_ITEMS = 'RSS_LISTING_RESET_SELECTED_ITEMS';
export const RSS_LISTING_TABLE_URL_CHANGE = 'RSS_LISTING_TABLE_URL_CHANGE';
export const RSS_LISTING_SET_SELECTION = 'RSS_LISTING_SET_SELECTION';

const actions = {

    resetFeedListingPageToInitial: () => {
        reduxStore.dispatch({type: RSS_LISTING_INITIAL_PHASE});
        headerActions.updateHeader('feedListing');
    },

    loadCategories: () => {

        reduxStore.dispatch(
            {
                type: 'SHOW_SPINNER'
            }
        );

        return categoriesApi
            .getCategoryNames()
            .then((categories) => {
                reduxStore.dispatch(
                    {
                        type: RSS_LISTING_LOAD_CATEGORIES,
                        payload: categories
                    }
                );
                reduxStore.dispatch(
                    {
                        type: 'HIDE_SPINNER'
                    }
                );
            }).catch((error) => {
                console.log("*************** Failed get categories for feed listing ****************");
                xhr.handleAllErrors(error);
            });
    },

    toggleDeleteConfirmation: (stage) => {

        if (stage !== 'rss-listing-warning-shown') {
            reduxStore.dispatch({type: RSS_LISTING_WARNING_SHOWN});
        } else {
            reduxStore.dispatch({type: RSS_LISTING_WARNING_HIDDEN});
        }

    },

    tooltipHandlerEnter(e) {

        //pestleBarsContainer is the element the event handler has been attached to
        let pestleBarsContainer = e.currentTarget,
            tooltip             = pestleBarsContainer.getElementsByClassName('tooltip')[0];

        pestleBarsContainer.onmousemove = function(e) {
            //get the cursor x and y positions and inline-style the tooltip (tooltip is position: fixed)
            let x = (e.clientX) + 'px',
                y = (e.clientY + 25) + 'px';
            tooltip.style.top = y;
            tooltip.style.left = x;
        };

    },

    selectItem(itemId) {
        reduxStore.dispatch({
            type:    RSS_LISTING_SELECT_ITEM,
            payload: itemId
        });
    },

    deselectItem(itemIndex) {
        reduxStore.dispatch({
            type:    RSS_LISTING_DESELECT_ITEM,
            payload: itemIndex
        });
    },

    resetSelectedItems() {
        reduxStore.dispatch({type: RSS_LISTING_RESET_SELECTED_ITEMS});
    },

    refreshFeedsList: () => {
        reduxStore.dispatch({type: RSS_LISTING_REFRESH_FEEDS});
    },

    deleteFeeds: (selectedItems) => {

        // Hide delete warning modal and show spinner
        reduxStore.dispatch({type: RSS_LISTING_WARNING_HIDDEN});
        reduxStore.dispatch({type: 'SHOW_SPINNER'});

        return xhr.delete({
            url: '/api/feeds/',
            data: selectedItems
        }).then((response) => {
            actions.resetSelectedItems();
            actions.refreshFeedsList();
            reduxStore.dispatch({type: 'HIDE_SPINNER'});
        }).catch((error) => {
            if (error.status === 400) {
                reduxStore.dispatch({type: 'HIDE_SPINNER'});

                // Show error message of validation request fail.
                popupActions.setMessages({
                    popupTitle: null,
                    messages:   [
                        {
                            messageId:   'feedListing.deleteError',
                            messageType: 'system-error'
                        }
                    ]
                });

                // Hide the message after 5 seconds.
                setTimeout(popupActions.removeMessage, POPUP_LIFETIME);
            } else {
                xhr.handleAllErrors(error);
            }
        });

    },

    countEntries: () => {
        let url = '/api/feeds/count/RMM';
        reduxStore.dispatch({type: RSS_LISTING_COUNT, payload: null});

        xhr.get({
            url:     url
        }).then((response) => {
            reduxStore.dispatch({type: RSS_LISTING_COUNT, payload: response.body});
        }).catch((error) => {
            utils.logError(error, 'FeedListing.actions.countEntries(): ');
            if (error.status === 400) {
                reduxStore.dispatch({type: RSS_LISTING_COUNT, payload: 0});
            } else {
                xhr.handleAllErrors(error);
            }
        });
    },



    refreshTable: () => {
        let refreshToggle = reduxStore.getState().feedListing.urlParams.refreshToggle;

        reduxStore.dispatch({
            type:    RSS_LISTING_TABLE_URL_CHANGE,
            payload: {
                refreshToggle: refreshToggle === 0 ? 1 : 0
            }
        });
    },

    goToAddRssFeed: () => {
        hashHistory.push('/add-new-feed')
    },

    setSelectedItems: (selectedItems) => {
        reduxStore.dispatch({
            type:    RSS_LISTING_SET_SELECTION,
            payload: selectedItems
        });
    },

    selectAll: () => {
        let state = reduxStore.getState().feedListing;

        return xhr.get({
            url: '/api/feeds/',
            data: {
                pageNumber: -1,
                pageSize: -1,
                sortBy: state.urlParams.sortBy,
                direction: state.urlParams.direction
            }
        }).then((response) => {
            actions.setSelectedItems(response.body);
        }).catch((err) => {
            console.log("********************** Failed to select all ********************");
            console.log(err);
            xhr.handleAllErrors(err);
        });
    }

};

export default actions;


// WEBPACK FOOTER //
// ./src/scripts/pages/FeedListing/FeedListing.actions.js